// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

export class Node {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):Node {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsNode(bb:flatbuffers.ByteBuffer, obj?:Node):Node {
  return (obj || new Node()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsNode(bb:flatbuffers.ByteBuffer, obj?:Node):Node {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new Node()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

id():string|null
id(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
id(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

componentId():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

parentIndex():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

childIndices(index: number):number|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readInt32(this.bb!.__vector(this.bb_pos + offset) + index * 4) : 0;
}

childIndicesLength():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
}

childIndicesArray():Int32Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? new Int32Array(this.bb!.bytes().buffer, this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset), this.bb!.__vector_len(this.bb_pos + offset)) : null;
}

layoutOpStart():number {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

layoutOpCount():number {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

designOpStart():number {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

designOpCount():number {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

eventBindingStart():number {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

eventBindingCount():number {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

stateBindingStart():number {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

stateBindingCount():number {
  const offset = this.bb!.__offset(this.bb_pos, 26);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

propOpStart():number {
  const offset = this.bb!.__offset(this.bb_pos, 28);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

propOpCount():number {
  const offset = this.bb!.__offset(this.bb_pos, 30);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
}

static startNode(builder:flatbuffers.Builder) {
  builder.startObject(14);
}

static addId(builder:flatbuffers.Builder, idOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, idOffset, 0);
}

static addComponentId(builder:flatbuffers.Builder, componentId:number) {
  builder.addFieldInt32(1, componentId, 0);
}

static addParentIndex(builder:flatbuffers.Builder, parentIndex:number) {
  builder.addFieldInt32(2, parentIndex, -1);
}

static addChildIndices(builder:flatbuffers.Builder, childIndicesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, childIndicesOffset, 0);
}

static createChildIndicesVector(builder:flatbuffers.Builder, data:number[]|Int32Array):flatbuffers.Offset;
/**
 * @deprecated This Uint8Array overload will be removed in the future.
 */
static createChildIndicesVector(builder:flatbuffers.Builder, data:number[]|Uint8Array):flatbuffers.Offset;
static createChildIndicesVector(builder:flatbuffers.Builder, data:number[]|Int32Array|Uint8Array):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (let i = data.length - 1; i >= 0; i--) {
    builder.addInt32(data[i]!);
  }
  return builder.endVector();
}

static startChildIndicesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
}

static addLayoutOpStart(builder:flatbuffers.Builder, layoutOpStart:number) {
  builder.addFieldInt32(4, layoutOpStart, 0);
}

static addLayoutOpCount(builder:flatbuffers.Builder, layoutOpCount:number) {
  builder.addFieldInt32(5, layoutOpCount, 0);
}

static addDesignOpStart(builder:flatbuffers.Builder, designOpStart:number) {
  builder.addFieldInt32(6, designOpStart, 0);
}

static addDesignOpCount(builder:flatbuffers.Builder, designOpCount:number) {
  builder.addFieldInt32(7, designOpCount, 0);
}

static addEventBindingStart(builder:flatbuffers.Builder, eventBindingStart:number) {
  builder.addFieldInt32(8, eventBindingStart, 0);
}

static addEventBindingCount(builder:flatbuffers.Builder, eventBindingCount:number) {
  builder.addFieldInt32(9, eventBindingCount, 0);
}

static addStateBindingStart(builder:flatbuffers.Builder, stateBindingStart:number) {
  builder.addFieldInt32(10, stateBindingStart, 0);
}

static addStateBindingCount(builder:flatbuffers.Builder, stateBindingCount:number) {
  builder.addFieldInt32(11, stateBindingCount, 0);
}

static addPropOpStart(builder:flatbuffers.Builder, propOpStart:number) {
  builder.addFieldInt32(12, propOpStart, 0);
}

static addPropOpCount(builder:flatbuffers.Builder, propOpCount:number) {
  builder.addFieldInt32(13, propOpCount, 0);
}

static endNode(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createNode(builder:flatbuffers.Builder, idOffset:flatbuffers.Offset, componentId:number, parentIndex:number, childIndicesOffset:flatbuffers.Offset, layoutOpStart:number, layoutOpCount:number, designOpStart:number, designOpCount:number, eventBindingStart:number, eventBindingCount:number, stateBindingStart:number, stateBindingCount:number, propOpStart:number, propOpCount:number):flatbuffers.Offset {
  Node.startNode(builder);
  Node.addId(builder, idOffset);
  Node.addComponentId(builder, componentId);
  Node.addParentIndex(builder, parentIndex);
  Node.addChildIndices(builder, childIndicesOffset);
  Node.addLayoutOpStart(builder, layoutOpStart);
  Node.addLayoutOpCount(builder, layoutOpCount);
  Node.addDesignOpStart(builder, designOpStart);
  Node.addDesignOpCount(builder, designOpCount);
  Node.addEventBindingStart(builder, eventBindingStart);
  Node.addEventBindingCount(builder, eventBindingCount);
  Node.addStateBindingStart(builder, stateBindingStart);
  Node.addStateBindingCount(builder, stateBindingCount);
  Node.addPropOpStart(builder, propOpStart);
  Node.addPropOpCount(builder, propOpCount);
  return Node.endNode(builder);
}
}
